import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  "NAME": (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};



const duck = createDuck("GET_USUARIOS", newActions, newReducers);

const getUsuariosThunk = (page, limit) => {
  const url = `${baseUrl}/getUsuarios?page=${page}&limit=${limit}`;
  return createThunk(axios, "get", duck.actions, url);
};

export default {
  duck,
  getUsuariosThunk,
};
